import { useMemo } from "react"

import { blocks as BLOCKS } from "@/components/builder/blocks"

import TemplateEngine from "../compiler"

export default function useCompiler() {
  const palette = usePalette(BLOCKS)
  const templates = useMemo(() => BLOCKS.map(({ key, Template }) => ({ key, Template })), [])
  const resolver = useMemo(() => BLOCKS.reduce((resolver, { key, Component }) => ({
    ...resolver,
    [key]: Component,
  }), {}), [])

  const engine = useMemo(() => {
    const engine = new TemplateEngine()
    for (const { key, Template } of templates) {
      engine.defineComponent({ Template, key })
    }
    return engine
  }, [templates])

  return useMemo(() => ({
    palette, templates, resolver, engine,
  }), [palette, templates, resolver, engine])
}

/**
 * @template Block
 * @template {Block['palette']} PalleteBlock
 * @param {Block[]} blocks
 */

function usePalette(blocks) {
  return useMemo(() => {
    class Category {
      constructor(name) {
        this.name = name
        /** @type {PalleteBlock[]} */
        this.items = []
      }

      add(palette) {
        this.items.push(palette)
      }
    }

    /**
     * @type {Category[]}
     */
    const categories = []
    for (const block of blocks) {
      const { palette, key } = block
      categories[key] = block
      if (palette) {
        const name = palette.category || 'default'
        const category = categories[name] || new Category(name)
        if (!categories[name]) {
          categories.push(category)
          categories[name] = category
        }
        category.add(palette)
      }
    }
    return categories
  }, [blocks])
}
